<template>
  <NewBsBox
    class="tab-headers"
    :class="{
      'header-line': showBottomLine,
      'header-center': centered
    }"
    :bs="{
      'cmp.tab': 'headers',
      ...wrapperBs,
      ...bs,
    }"
  >
    <slot name="actionBefore" />
    <TabItem
      v-for="item in list"
      :key="item.name"
      :active="item.name === modelValue"
      :disabled="item.disabled"
      :bs="itemBs"
      :size="size"
      :modifier="modifier"
      :item="item"
      @click="() => handleClickItem(item)"
    />
    <NewBsBox
      v-if="$slots.action || $slots.actionAfter"
      :bs="{ ml: 'auto', display: 'flex', alignItems: 'center' }"
    >
      <slot name="actionAfter" />
      <slot name="action" />
    </NewBsBox>
  </NewBsBox>
</template>
<script lang="ts">
  import {
    PropType,
    defineComponent,
  } from 'vue'
  import { BeerStyleObj } from '../../../core'
  import NewBsBox from '../../primitive/NewBsBox'
  import initStyle from './style.js'
  import TabItem from './TabItem.vue'
  import {
    TabItemModifier,
    TabHeaderItem,
  } from './TabD'

  initStyle()
  /**
   * 切换标签
   */
  export default defineComponent({
    name: 'BeerTabHeaders',
    components: {
      NewBsBox,
      TabItem,
    },
    props: {
      /** headerList */
      list: {
        type: Array as PropType<TabHeaderItem[]>,
        default: () => ([]),
      },
      /**
       * primary | success | danger | warning | secondary
       * @type {primary|success|danger|warning|secondary}
       * @see style
       */
      modifier: {
        type: String as PropType<TabItemModifier>,
        default: 'primary',
      },
      /**
       * 当前激活的tab  name
       */
      modelValue: {
        type: [Number, String] as PropType<string | number>,
      },
      /**
       * 是否显示底部分割线
       */
      showBottomLine: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
      /**
       * 是否居中
       */
      centered: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
      /**
       * @ignore
       * @deprecated
       * 使用 BS 即可
       */
      wrapperBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 容器 BeerStyle
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 每个标签的 BeerStyle
       */
      itemBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * 标签的大小和空间
       * @type {s|m|l}
       */
      size: {
        type: String,
        default: 'm',
      },
      /**
       * 点击HeaderItem的回调函数
       */
      handleClickItem: {
        type: Function,
        default: () => ({}),
      },
    },
  })
</script>
